import { render, staticRenderFns } from "./VendorEdit.vue?vue&type=template&id=a816007c&"
import script from "./VendorEdit.vue?vue&type=script&lang=js&"
export * from "./VendorEdit.vue?vue&type=script&lang=js&"
import style0 from "./VendorEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports